// src/features/medicalSercices/page/roleForm.tsx

import { API_ENDPOINTS, QUERY_KEYS } from '../../api/apiEndpoints';
import DynamicForm, { type DynamicFormSchema } from '@/common/components/DynamicForm/DynamicForm';
import { useTranslation } from 'react-i18next';

export default function RoleForm() {
    const { t } = useTranslation();

    const roleFormSchema: DynamicFormSchema = {
        layout: 'vertical', // Overall form layout
        // submitButtonText: 'Save User', // Custom text for the submit button
        showResetButton: true, // Show a reset button

        // Define form sections for better organization and complex layouts
        sections: [
            {
                key: 'role-details', // Unique key for the section
                title: t('Role From'), // Title displayed if type is 'card'
                type: 'card', // This section will be rendered inside an Ant Design Card
                layout: { type: 'grid', gutter: 24 }, // Fields within this section use a 2-column grid with 24px gutter
                fields: [

                    {
                        name: 'name',
                        label: 'Name',
                        type: 'input',
                        required: true,
                        requiredMessage: 'Please enter a name.', // Custom required message
                        pattern: 'AlphabetsWithSpace',
                        validation: [
                            { min: 2, message: t('name must be at least 2 characters long.') },
                            { max: 20, message: t('name cannot be more than 20 characters long.') },
                        ],

                        autocomplete: 'false',

                        colSpan: 12, // Takes 12 out of 24 grid units (half width)
                    },
                ],
            },

        ],
    };

    return (
        <DynamicForm
            schema={roleFormSchema}
            submitApiUrl={API_ENDPOINTS.MANAGEMENT.SAVE_ROLE}
            getByIdApiUrl={API_ENDPOINTS.MANAGEMENT.GET_ROLE_BY_ID}
            updateApiUrl={API_ENDPOINTS.MANAGEMENT.UPDATE_ROLE}
            refreshTableDataKey={QUERY_KEYS.MANAGEMENT.ROLES}
        />
    );
}
